/** ISO 8601 (UTC `Z`) interval boundary granularity used by AOA `getCountingHistory`. */
export const BUCKET_GRANULARITY_MS = 15 * 60 * 1000;

export const FEATURE_NAME = "traffic-flow";
